import FeedPreview from './FeedPreview';

export default FeedPreview;

